/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/promptQaDuplicateCount.ts
 * FILE_ID: JOBHUB-QA-DUPLICATE-COUNT-001
 * PURPOSE: Ask how many copies to make before duplicate-many runs.
 */
import { promptDialog } from '@quotech/ui'

export async function promptQaDuplicateCount(sourceCount: number): Promise<number | null> {
  // Reused from: packages/ui/src/components/PromptDialog.tsx (promptDialog)
  const value = await promptDialog({
    title: sourceCount === 1 ? 'Duplicate QA' : `Duplicate ${sourceCount} QAs`,
    description: 'The QA and its copies go into a new group named after the QA.',
    inputLabel: 'Number of duplicates',
    defaultValue: '1',
    submitLabel: 'Duplicate',
    required: true,
    validate: (raw) => {
      const n = Number(raw.trim())
      if (!Number.isInteger(n) || n < 1 || n > 100) return 'Enter a whole number from 1 to 100'
      return null
    },
  })
  if (value == null) return null
  return Number(value.trim())
}
